const celebrating = "/_app/immutable/assets/flexy-happy-young-man-celebrating-something.DkioJdkX.svg";
export {
  celebrating as default
};
